import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import Sidebar from './Sidebar'
import RightSidebar from './RightSidebar'
import CreatePostModal from './CreatePostModal'
import MediaPreviewOverlay from '../pages/MediaPreview'

export default function Layout() {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="flex flex-1 max-w-7xl mx-auto w-full">
        {/* Left Sidebar - Navigation */}
        <div className="sidebar-border-right">
          <Sidebar />
        </div>

        {/* Main Content — fixed width like Twitter, doesn't stretch */}
        <main className="w-[600px] min-w-[600px] main-content-border">
          <Outlet />
        </main>

        {/* Right Sidebar - Trending & Suggestions */}
        <RightSidebar />
      </div>

      {/* Floating Create Post — mobile web only */}
      <button
        onClick={() => setShowCreateModal(true)}
        className="xl:hidden fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg z-40 flex items-center justify-center hover:scale-105 transition-transform"
      >
        <img src="/logo.svg" alt="Post" className="w-14 h-14" />
      </button>

      <CreatePostModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />

      {/* Media Preview Overlay — renders on top, feed stays mounted */}
      <MediaPreviewOverlay />
    </div>
  )
}
